export default __webpack_public_path__ + "static/2_21-1700f3a9d5ac3286eed4d7d4a625df6a.png";